"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var ExitGrouping = __importStar(require("./O_ExitGrouping"));
var FullScreenTakeover = __importStar(require("./T_FullScreenTakeover"));
var Component = function (p) {
    return (Preact.h(FullScreenTakeover.Component, null,
        Preact.h(Box_1.default, { sx: { width: { xs: '363px', sm: '394px' } } },
            Preact.h(ExitGrouping.Component, { onExit: p.onExit, onCancel: p.onCancel, size: p.size, sharingUrlResult: p.sharingUrlResult, sharingUrlError: p.sharingUrlError, sharingUrlRetry: p.sharingUrlRetry, copyToClipboard: p.copyToClipboard, primaryCtaText: p.primaryCtaText, secondaryCtaText: p.secondaryCtaText, titleText: p.titleText, linkError: p.linkError, linkHelperText: p.linkHelperText, linkLoading: p.linkLoading, linkCtaText: p.linkCtaText }))));
};
exports.Component = Component;
exports.Component.displayName = 'ExitScreen';
